/**
 * First forward intersection of a ray with an axis-aligned wall set.
 *
 * When no wall is hit forward (e.g. flightGap=0, where every inner wall passes
 * through the pivot) the pivot itself is returned so the corner collapses cleanly
 * there instead of propagating Infinity into the polygon and erasing the step.
 */
export function rayWallIntersection(
    px: number,
    pz: number,
    dx: number,
    dz: number,
    walls: readonly { readonly axis: 'x' | 'z'; readonly value: number }[]
): { x: number; z: number } {
    let minT: number = Infinity;

    for (const wall of walls) {
        let t: number;
        if (wall.axis === 'x' && Math.abs(dx) > 1e-10) {
            t = (wall.value - px) / dx;
        } else if (wall.axis === 'z' && Math.abs(dz) > 1e-10) {
            t = (wall.value - pz) / dz;
        } else {
            continue;
        }
        if (t > 1e-10 && t < minT) {
            minT = t;
        }
    }

    if (!Number.isFinite(minT)) {
        return { x: px, z: pz };
    }
    return { x: px + dx * minT, z: pz + dz * minT };
}
